export const useStoredValue = <T>(key: string, defaultValue: T) => {
    const setValue = (value: T) => localStorage.setItem(key, JSON.stringify(value));
    const stringValue = localStorage.getItem(key);
    if (!stringValue) {
        return [defaultValue, setValue];
    }

    const value = JSON.parse(stringValue);
    return [value, setValue];
}